var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "stats-list" }, [
    _c("li", [
      _c("i", { staticClass: "fas fa-calendar-alt" }),
      _vm._v(" "),
      _c("span", { staticClass: "stat" }, [
        _vm._v(_vm._s(_vm._f("currencySafe")(_vm.rates.total)))
      ]),
      _vm._v(" in total\n\t")
    ]),
    _vm._v(" "),
    _c("li", [
      _c("i", { staticClass: "fas fa-calendar-day" }),
      _vm._v(" "),
      _c("span", { staticClass: "stat" }, [
        _vm._v(_vm._s(_vm._f("currencySafe")(_vm.rates.perDay)))
      ]),
      _vm._v(" per day\n\t")
    ]),
    _vm._v(" "),
    _c("li", [
      _c("i", { staticClass: "fas fa-calendar-week" }),
      _vm._v(" "),
      _c("span", { staticClass: "stat" }, [
        _vm._v(_vm._s(_vm._f("currencySafe")(_vm.rates.perWeek)))
      ]),
      _vm._v(" per week\n\t")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }